import { Bubble, Props } from './Bubble';
import { ChatIcon, PhoneIcon } from '@raysee/icon';
import { Message, generatePriceText } from '@raysee/schema';
import Image from 'next/image';
import { FC } from 'react';

interface BubbleProps extends Props {
  onClick?: (url: string, message: Message) => void;
}

export const PlanCarouselBubble: FC<BubbleProps> = (props) =>
  props.message.suggestNextPlans.length ? (
    <div>
      <Bubble {...props}>
        <div className="rounded-2xl border bg-white px-4 py-3 drop-shadow-sm">
          <p className="whitespace-pre-wrap">{props.message.text}</p>
        </div>
      </Bubble>
      <div className="mx-4 mb-4">
        <div
          className={`flex ${
            props.message.suggestNextPlans.length === 1 ? 'justify-center' : ''
          } gap-4 overflow-x-auto pb-5`}
        >
          {props.message.suggestNextPlans.map((plan, i) => (
            <button
              key={i}
              className="min-w-[208px] basis-[208px] rounded-xl bg-white text-left drop-shadow-xl"
              onClick={() =>
                props.onClick &&
                props.onClick(
                  `${window.location.origin}/tellers/${plan.tellerId}/plans/${plan.id}`,
                  props.message,
                )
              }
            >
              <div>
                <Image
                  src={plan.imageUrl}
                  alt={plan.title}
                  width={208}
                  height={117}
                  className="rounded-t-xl"
                />
                <div className="w-full px-4 pb-3 pt-1">
                  <div className="line-clamp-2 pb-1 text-sm font-bold text-black">{plan.title}</div>
                  <div className="text-brand truncate pb-2">
                    {plan.categories.map((category, i) => (
                      <span key={i} className="mr-2 text-xs font-bold">
                        #{category}
                      </span>
                    ))}
                  </div>
                  <div className="flex justify-end text-right">
                    <div className="flex h-6 w-6 items-center justify-center rounded-sm bg-[#6B6B6B]">
                      {plan.type === 'phone' ? (
                        <PhoneIcon width={18} height={18} />
                      ) : (
                        <ChatIcon width={18} height={18} />
                      )}
                    </div>
                    <span className="pl-1">{generatePriceText(plan)}</span>
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
